import apiRoutes from './api.routes';
import api from './api.service';
import ModelService from './model.service';
import dih from '../helpers/defaultImages.helper';
import flh from '../helpers/file.helper';

const UserService = new ModelService(apiRoutes.users, '/users', 'users');

UserService.createInvite = async model => api.catchError(async () => {
  const { data } = await api.post(apiRoutes.createInvite, model);
  return data;
});

UserService.defaultAvatar = dih.defaultUserLogo;

UserService.getAvatar = ({ avatar, avatar_url, filename, token }, w = false, h = false, c = false) => {
  if (filename) return UserService.getFilePathByDir(`/uploads/${api.subdomain}/users`, filename, w, h, c);
  if (avatar) {
    if (Number(avatar, 10)) return flh.createLink(avatar, token);
    else if (avatar.filename) return UserService.getFilePathByDir(`/uploads/${api.subdomain}/users`, avatar.filename, w, h, c);
  } else if (avatar_url) return avatar_url;
  return UserService.defaultAvatar;
};

UserService.getUserName = ({ t, user }) => {
  if (user) return user.first_name || user.last_name ? `${user.first_name || ''}${user.last_name ? ` ${user.last_name}` : ''}` : user.email;
  return t('someone');
};

UserService.STATUS_ACTIVE = 1;
UserService.STATUS_INACTIVE = 0;
UserService.STATUS_UNDER_REVIEW = 2;
UserService.STATUS_PENDING = 3;

UserService.getStatusList = t => ({
  [UserService.STATUS_ACTIVE]: t('Active'),
  [UserService.STATUS_INACTIVE]: t('Inactive'),
  [UserService.STATUS_UNDER_REVIEW]: t('Under review'),
  [UserService.STATUS_PENDING]: t('Pending'),
});

UserService.getStatusOptions = t => UserService
  .prepareOptionsFromSimpleObject(UserService.getStatusList(t));

UserService.getStatusTitle = (status, t) => {
  const label = UserService.getStatusList(t)[status];
  return label || '-';
};

UserService.EMAIL_RESET_PASS = 5;
UserService.EMAIL_WELCOME = 4;
UserService.EMAIL_APPROVAL = 3;
UserService.EMAIL_CONFIRM_EMAIL = 2;
UserService.EMAIL_INVITE_COMPANY = 1;

UserService.NEW_KB = 6; //New article in our KB
UserService.NEW_BLOG = 7; //New post available
UserService.ANSWER_TICKET = 8; // Answer to your ticket
UserService.TICKET_RESOLVER = 9; // - Your problem is solved?
UserService.TICKET_AUTO_CLOSE = 10; // Auto close for your ticket
UserService.TICKET_CLOSED = 11; // Ticket closed
UserService.NEW_DOC = 12; //New document available for you
UserService.FEEDBACK_NEW_COMMENT = 13; // New comment on a card you follow
UserService.FEEDBACK_STATUS_CHANGED = 14; // Status changed for a card you follow
UserService.NEW_MESSAGE = 15; //XX sent you a message (when not viewed online)
UserService.TYPE_DOCUMENT_NEW_COMMENT = 17;

UserService.getEmailTokens = t => ({
  [UserService.NEW_KB]: t('New article in our KB'),
  [UserService.NEW_BLOG]: t('New post available'),
  [UserService.ANSWER_TICKET]: t('Answer to your ticket'),
  [UserService.TICKET_RESOLVER]: t('Your problem is solved?'),
  [UserService.TICKET_AUTO_CLOSE]: t('Auto close for your ticket'),
  [UserService.TICKET_CLOSED]: t('Ticket closed'),
  [UserService.NEW_DOC]: t('New document available for you'),
  [UserService.FEEDBACK_NEW_COMMENT]: t('New comment on a card you follow'),
  [UserService.FEEDBACK_STATUS_CHANGED]: t('Status changed for a card you follow'),
  [UserService.NEW_MESSAGE]: t('XX sent you a message'),
  [UserService.TYPE_DOCUMENT_NEW_COMMENT]: t('New comment on a document'),
});

UserService.getColorByStatus = (status) => {
  switch (status) {
    case UserService.STATUS_ACTIVE:
      return 'success';
    case UserService.STATUS_INACTIVE:
      return 'danger';
    case UserService.STATUS_UNDER_REVIEW:
      return 'warning';
    case UserService.PENDING:
      return 'warning';
    default:
      return 'secondary';
  }
};

UserService.variables = [
  '{{first_name}}',
  '{{last_name}}',
  '{{full_name}}',
  '{{company_name}}',
  '{{email}}',
  '{{phone}}',
];

UserService.getVariablesForUser = (user) => {
  return [
    { key: '{{first_name}}', value: user ? user.first_name : '' },
    { key: '{{last_name}}', value: user ? user.last_name : '' },
    { key: '{{full_name}}', value: user ? user.first_name + user.last_name : '' },
    { key: '{{company_name}}', value: user ? user.company_name : '' },
    { key: '{{email}}', value: user ? user.email : '' },
    { key: '{{phone}}', value: user ? user.phone : '' },
  ];
};

UserService.replaceVariables = (user, text) => {
  text = text || '';
  const vars = UserService.getVariablesForUser(user);
  vars.forEach((v) => {
    text = text.split(v.key).join(v.value);
  });
  return text;
};

export default UserService;



// WEBPACK FOOTER //
// ./src/services/user.service.js